import StoryblokClient from 'storyblok-js-client/dist/es5/index.cjs'
import { STORYBLOK_TOKEN } from 'Config/config'


export const transformImage = (image, option) => {
  if(!image) return ''
  const imageService = '//img2.storyblok.com/'
  const path = image.replace('//a.storyblok.com', '')
  return imageService + option + path
}

class StoryblokService {
  constructor() {
    // TO DO Change this to false before pushing to production to only show published pages
    this.devMode = process.env.NODE_ENV !== 'production' // if true always loads draft
    this.token = STORYBLOK_TOKEN
    this.client = new StoryblokClient({
      accessToken: this.token,
      cache: {
        clear: 'auto',
        type: 'memory',
      },
    })

    this.query = {}
  }

  getCacheVersion() {
    return this.client.cacheVersion
  }

  get(slug, params) {
    const newParams = params || {}

    if(this.getQuery('_storyblok') || this.devMode || (typeof window !== 'undefined' && window.storyblok)) {
      newParams.version = 'draft'
    }

    if(typeof window !== 'undefined' && typeof window.StoryblokCacheVersion !== 'undefined') {
      newParams.cv = window.StoryblokCacheVersion
    }

    return this.client.get(slug, newParams)
  }

  getAsync = async (slug, params) => {
    const newParams = params || {}

    if(this.getQuery('_storyblok') || this.devMode || (typeof window !== 'undefined' && window.storyblok)) {
      newParams.version = 'draft'
    }

    if(typeof window !== 'undefined' && typeof window.StoryblokCacheVersion !== 'undefined') {
      newParams.cv = window.StoryblokCacheVersion
    }
    const res = await this.client.get(slug, newParams)
    return res
  }

  initEditor(reactComponent) {
    if(typeof window !== 'undefined' && window.storyblok) {
      window.storyblok.init()
      // eslint-disable-next-line
      window.storyblok.on(['change', 'published'], () => location.reload(true))
      // this will alter the state and replaces the current story
      // with a current raw story object (no resolved relations or links)
      window.storyblok.on('input', (event) => {
        if(event.story.content._uid === reactComponent.state.pageContent._uid) {
          reactComponent.setState({ pageContent: window.storyblok.addComments(event.story.content, event.story.id) })
        }
      })
    }
  }

  setQuery(query) {
    this.query = query
  }

  getQuery(param) {
    return this.query[param]
  }

  bridge() {
    if(!this.getQuery('_storyblok') && !this.devMode) {
      return ''
    }
    return '//app.storyblok.com/f/storyblok-latest.js?t=' + this.token
    // return <script src={'//app.storyblok.com/f/storyblok-latest.js?t=' + this.token} />
  }

  getClient() {
    return this.client
  }

  richTextResolver(richtext) {
    if(richtext) {
      return this.client.richTextResolver.render(richtext)
    }
  }
}

const storyblokInstance = new StoryblokService()

export default storyblokInstance
